import { Container, Row, Col } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import LoginOrSignup from './login/loginorsignup';
import CreateOrJoin from './setup/createorjoin';
import Header from './helpers/header';
import UserBubble from './helpers/userbubble';
import MenuBubble from './helpers/menububble';
import { uiState } from '../redux/_constants';
import { heroLogo } from './helpers/logos';
import LoginBubble from './helpers/loginbubble';
import MatchupGrid from './helpers/matchupgrid';
import Privacy from './helpers/privacy';
import Terms from './helpers/terms';
import Footer from './helpers/footer';
import { useLocation } from 'react-router-dom';
import { useUser } from '../user-provider';
import CookieBanner from '../utilities/cookie';
import GetSiteSettings from '../apollo/queries/GetSiteSettings.graphql';

const GLOBAL_SETTINGS_ID = 'homepage';
const getSeasonSettingsId = (seasonNum) => `Season ${seasonNum}`;

function Home() {
  const { user, isAuthenticating } = useUser();
  const location = useLocation();
  const { PRIVACY, TERMS } = uiState;

  // Check for season URL parameter
  const params = new URLSearchParams(window.location.search);
  const seasonParam = params.get('season');
  const previewSeason = seasonParam ? parseInt(seasonParam, 10) : null;

  // Load global settings to get active season (skip until auth resolves)
  const { data: globalData } = useQuery(GetSiteSettings, {
    variables: { id: GLOBAL_SETTINGS_ID },
    fetchPolicy: 'cache-first',
    skip: isAuthenticating,
  });

  // Determine which season to show (URL param takes precedence)
  const activeSeason =
    previewSeason || globalData?.getSiteSettings?.currentSeason || 6;

  // Load season-specific settings for the label (skip until auth resolves)
  const { data: seasonData } = useQuery(GetSiteSettings, {
    variables: { id: getSeasonSettingsId(activeSeason) },
    fetchPolicy: previewSeason ? 'network-only' : 'cache-first',
    skip: isAuthenticating,
  });

  const seasonLabel =
    seasonData?.getSiteSettings?.seasonLabel || `Season ${activeSeason}`;

  const mainContent = () => {
    switch (location.pathname) {
      case PRIVACY:
        return <Privacy />;
      case TERMS:
        return <Terms />;
      default:
        return <MatchupGrid />;
    }
  };

  const mainSubtitle = () => {
    switch (location.pathname) {
      case PRIVACY:
        return 'Privacy policy';
      case TERMS:
        return 'Terms of service';
      default:
        return 'Select match (local time)';
    }
  };

  const header = () => {
    if (
      user &&
      user.signInUserSession &&
      ['/privacy', '/terms'].includes(location.pathname)
    ) {
      return (
        <>
          <Header>
            <UserBubble />
            <MenuBubble />
          </Header>
          <CreateOrJoin />
        </>
      );
    } else {
      return (
        <>
          <Header>
            <MenuBubble />
            <LoginBubble />
          </Header>
          <LoginOrSignup />
        </>
      );
    }
  };

  return (
    <div className="main">
      {header()}
      <Container>
        <Row style={{ height: 'calc(15vh - 72px)' }} />
        <Row
          style={{
            background: '#fff',
            padding: '1rem',
            zIndex: '100',
          }}
        >
          <Col className="center" style={{ display: 'flex', flexWrap: 'wrap' }}>
            <div className="heroLogo"> {heroLogo} </div>
            <div className="heroTagline">{seasonLabel}</div>
            <div className="heroItalic" style={{ fontStyle: 'italic' }}>
              {mainSubtitle()}
            </div>
          </Col>
        </Row>
        <Row style={{ height: '50vh' }}>
          <Col className="center" style={{ display: 'flex', flexWrap: 'wrap' }}>
            {mainContent()}
          </Col>
        </Row>
      </Container>
      <Footer />
      <CookieBanner />
    </div>
  );
}

export default Home;
